/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Remove_Empty_TableInputs */



/**
* | output |
* | --- |
* | "Remove empty table" |
*
* @param {Rounds_Remove_Empty_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_remove_empty_table = /** @type {((inputs?: Rounds_Remove_Empty_TableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Remove_Empty_TableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer la table vide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar mesa vacía")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover mesa vazia")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi tavolo vuoto")
	return /** @type {LocalizedString} */ ("Remove empty table")
});